import { IonRefresher } from "@ionic/react";
import React from "react";

const GlobalPageRefresher: React.FC = () => {
  const handleRefresh = (event: CustomEvent) => {
    // Trigger a full browser refresh
    window.location.reload();

    // Complete the refresher animation after the page reloads
    event.detail.complete();
  };

  return (
    <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
      {/* This is commented because when navigating to a page and then back using the browser back
            there are cases when the app crashes because of uninitialized value error from this component */}
      {/* <IonRefresherContent /> */}
    </IonRefresher>
  );
};

export default GlobalPageRefresher;
